<template>
  <div>
    <a-card :bordered="false" style="">
      <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24" style="margin:16px 25px;">
              <!-- <a-col class="a-large-form">
                <a-form-item style="margin-bottom:0px" label="" :required="false">
                  <a-select defaultValue="全部角色">
                    <a-select-option value>全部角色</a-select-option>
                    <a-select-option value="0">管理员</a-select-option>
                    <a-select-option value="1">助教</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
             
              <a-button type="primary" style="margin-left:10px;float:right;" @click="roleCreate()">新增角色</a-button>
            </a-row>
            
          </a-form>
      </div>
      <div style="margin-top:10px;"> 
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="handleEdit(record)">删除</a>
          </span>
        </a-table>
        
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'BlackStudentList',
  // mixins: [],
  data() {
    return {
      selectedData: [],
      // 表头
      description: '员工角色页面',
      loading:false,
      columns: [
        {
          title: '角色',
          align: 'center',
          dataIndex: 'studentName'
        },
        {
          title: '描述',
          align: 'center',
          dataIndex: 'origin'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          width:150,
          scopedSlots: { customRender: 'action' },
        }
      ],
      dataSource: [
        {
          studentName: '管理员',
          origin: '具备"课程管理"、"预约管理"、"排课"、"交易管理"、"营销中心"等的相关权限'
        }
      ]
    }
  },
  methods: {
    roleCreate() {
      this.$router.push({ path: '/accountManage/createAccountRole' })
    },
    removeFromBlackList() {
      if (this.selectedData.length != 0) {
        this.$message.success('已移除')
      } else {
        this.$message.warning('请选择至少一条数据')
      }
    }
  },
  computed: {
    
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >

.fixed-tab-con {
  // display: none;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0px;
  left: 0px;
  text-align: center;
  width: 100%;
  padding-left: 220px;
  .fixed-tab {
    margin-top: 16px;
  }
}
</style>